window.Vue = require("vue");
import Vuex from "vuex";

//import Global Modules Vuex
import Gallery from "./stores/global/Gallery";
import Global from "./stores/global/Global";
import Main from "./stores/global/Main";
import Member from "./stores/global/Member";
import Module from "./stores/global/Module";
import Product from "./stores/global/Product";
import Profile from "./stores/global/Profile";
import Roles from "./stores/global/Roles";
import Select from "./stores/global/Select";
import Sidebar from "./stores/global/Sidebar";
import SyncUnion from "./stores/global/SyncUnion";
import Toolbar from "./stores/global/Toolbar";
import User from "./stores/global/User";

//import Reseller Modules Vuex
import Order from "./stores/reseller/Order";
import Dashboard from "./stores/reseller/Dashboard";

//Promotions
import Promo from "./stores/reseller/Promotions/Promo";
import PromoPrice from "./stores/reseller/Promotions/PromoPrice";
import PromoPercent from "./stores/reseller/Promotions/PromoPercent";
import PromoPercentDouble from "./stores/reseller/Promotions/PromoPercentDouble";
import PromoBuyGet from "./stores/reseller/Promotions/PromoBuyGet";
import PromoMinBuyGet from "./stores/reseller/Promotions/PromoMinBuyGet";
import PromoMinBuyGetMix from "./stores/reseller/Promotions/PromoMinBuyGetMix";
import PromoMinBuyGetMixDiscPrice from "./stores/reseller/Promotions/PromoMinBuyGetMixDiscPrice";
import PriceGroup from "./stores/reseller/PriceGroup";
import UserPriceGroup from "./stores/reseller/UserPriceGroup";

//import Website Modules Vuex
import Brand from "./stores/website/Brand";
import Diseases from "./stores/website/Diseases";
import Email from "./stores/website/Email";
import KeywordTag from "./stores/website/KeywordTag";
import LandingPage from "./stores/website/LandingPage";
import MemberBlacklist from "./stores/website/MemberBlacklist";
import MemberW from "./stores/website/Member";
import PopupBanner from "./stores/website/PopupBanner";
import FreeProduct from "./stores/website/FreeProduct";
import ProductWeb from "./stores/website/ProductWeb";
import Promotion from "./stores/website/Promotion";
import PromotionSugest from "./stores/website/PromotionSugest";
import PromoBadge from "./stores/website/promoBadge";
import Redirect from "./stores/website/Redirect";
import RefundWeb from "./stores/website/Refund";
import ShippingWeb from "./stores/website/Shipping";
import Store from "./stores/website/Store";
import Subscription from "./stores/website/Subscription";
import TrackAnteraja from "./stores/website/tracking/Anteraja";
import TrackGosend from "./stores/website/tracking/Gosend";
import TrackLalamove from "./stores/website/tracking/Lalamove";
import WebOrder from "./stores/website/Orders";
import SliderBanner from "./stores/website/SliderBanner";
import GenerateImageLink from "./stores/website/GenerateImageLink";
import Featured from "./stores/website/Featured";
import Bestseller from "./stores/website/Bestseller";
import NewProduct from "./stores/website/NewProduct";
import Flashsale from "./stores/website/Flashsale";
import Review from "./stores/website/Review";
import Discussion from "./stores/website/Discussion";
import ContactUs from "./stores/website/ContactUs";
import SeoMenu from "./stores/website/SeoMenu";
import SeoCategory from "./stores/website/SeoCategory";
import SeoProduct from "./stores/website/SeoProduct";
import SeoBrand from "./stores/website/SeoBrand";
import SeoDisease from "./stores/website/SeoDisease";
import NotificationHoliday from "./stores/website/NotificationHoliday";
import NotificationMember from "./stores/website/NotificationMember";
import HealthTools from "./stores/website/HealthTools";
import Referral from "./stores/website/Referral";

// import Union Modules Vuex
import OfflineStores from "./stores/union/OfflineStores";
import UnionStock from "./stores/union/UnionStock";
import UnionMember from "./stores/union/Member";
import PointMember from "./stores/union/PointMember";
// Synchronize
import DashboardIT from "./stores/union/DashboardIT";
import SyncMonitoring from "./stores/union/SyncMonitoring";
import StoreStatistics from "./stores/union/StoreStatistics";

// ORDER STORE
import OrderStores from "./stores/union/OrderStores";

// Point Member / Tier
import PointSetting from "./stores/union/PointSetting";

//POS Promotion
import PromotionPos from "./stores/union/PromotionPos";

// CAREER PAGE
import PageContent from "./stores/career/PageContent";
import Banner from "./stores/career/Banner";
import Career from "./stores/career/Career";
import ApplyJob from "./stores/career/ApplyJob";

// INVENTORY PAGE
import Allocation from "./stores/inv/Allocation";
import SelectInv from "./stores/inv/SelectInv";
import Stock from "./stores/inv/Stock";
import TransferInv from "./stores/inv/TransferInv";
import Warehouse from "./stores/inv/Warehouse";

// Human Resource Page
import ApprovalCuti from "./stores/hr/ApprovalCuti";
import ApprovalIzin from "./stores/hr/ApprovalIzin";
import Atk from "./stores/hr/Atk";
import Attendance from "./stores/hr/Attendance";
import DashboardCareer from "./stores/hr/DashboardCareer";
import Department from "./stores/hr/Department";
import Division from "./stores/hr/Division";
import Employee from "./stores/hr/Employee";
import FrontlinerCounter from "./stores/hr/FrontlinerCounter";
import FrontlinerStore from "./stores/hr/FrontlinerStore";
import Level from "./stores/hr/Level";
import Recruitment from "./stores/hr/Recruitment";
import LockerManagement from "./stores/hr/LockerManagement";
// Human Resource - Assessment
import Assessment from "./stores/hr/Assessment";
import PhoneExtension from "./stores/hr/PhoneExtension";

// Article Category
import ArticleCategory from "./stores/website/ArticleCategory";
import ArticleBlog from "./stores/website/ArticleBlog";
import ArticlePromotion from "./stores/website/ArticlePromotion";

// Server Resource Page
import UserServer from "./stores/server/UserServer";
import VsCode from "./stores/server/VsCode";

// Mailchimp
import Mailchimp from "./stores/website/Mailchimp";

// App
// import DashboardApp from "./stores/app/Dashboard";

// Tiktok
import CategoryTiktok from "./stores/tiktok/category/CategoryTiktok";
import Tiktok from "./stores/tiktok/order/Tiktok";

// Dashboard Stats
import DashboardExternal from "./stores/website/DashboardExternal"; // changed to DashboardIT
import DashboardStats from "./stores/website/DashboardStats";
import DashboardWebsite from "./stores/website/Dashboard";
import DashboardApp from "./stores/app/Dashboard";
import DashboardTiktok from "./stores/tiktok/Dashboard";
import DashboardReseller from "./stores/reseller/Dashboard";
import DashboardStore from "./stores/store/Dashboard";
import MainDashboard from "./stores/main/Dashboard";

// Employee Area
import Receipt from "./stores/employee/receipt";

//StockOpname
import StockOpname from "./stores/inv/StockOpname";

const store = new Vuex.Store({
  modules: {
    Allocation,
    ApplyJob,
    ApprovalCuti,
    ApprovalIzin,
    ArticleBlog,
    ArticleCategory,
    ArticlePromotion,
    Atk,
    Assessment,
    Attendance,
    Banner,
    Brand,
    Career,
    CategoryTiktok,
    Dashboard,
    DashboardApp,
    DashboardCareer,
    DashboardExternal,
    DashboardIT,
    DashboardReseller,
    DashboardStats,
    DashboardStore,
    DashboardTiktok,
    DashboardWebsite,
    Department,
    Diseases,
    Division,
    Email,
    Employee,
    FrontlinerCounter,
    FrontlinerStore,
    Gallery,
    GenerateImageLink,
    Featured,
    Bestseller,
    NewProduct,
    Global,
    KeywordTag,
    LandingPage,
    Level,
    Mailchimp,
    Main,
    MainDashboard,
    Member,
    MemberBlacklist,
    MemberW,
    Module,
    OfflineStores,
    Order,
    OrderStores,
    PageContent,
    PopupBanner,
    FreeProduct,
    PriceGroup,
    Product,
    ProductWeb,
    Profile,
    Promo,
    PromoBadge,
    PromoBuyGet,
    PromoMinBuyGet,
    PromoMinBuyGetMix,
    PromoMinBuyGetMixDiscPrice,
    PromoPercent,
    PromoPercentDouble,
    PromoPrice,
    Promotion,
    PromotionSugest,
    Receipt,
    Recruitment,
    Redirect,
    RefundWeb,
    Roles,
    Select,
    SelectInv,
    ShippingWeb,
    Sidebar,
    SliderBanner,
    Stock,
    Store,
    StoreStatistics,
    Subscription,
    SyncMonitoring,
    SyncUnion,
    Tiktok,
    Toolbar,
    TrackAnteraja,
    TrackGosend,
    TrackLalamove,
    TransferInv,
    UnionMember,
    UnionStock,
    User,
    UserPriceGroup,
    UserServer,
    VsCode,
    Warehouse,
    WebOrder,
    PointSetting,
    Flashsale,
    Review,
    Discussion,
    ContactUs,
    SeoMenu,
    SeoCategory,
    SeoProduct,
    SeoBrand,
    SeoDisease,
    NotificationHoliday,
    NotificationMember,
    PointMember,
    HealthTools,
    StockOpname,
    PromotionPos,
    PhoneExtension,
    LockerManagement,
    Referral,
  },
});
export default store;